var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlanetInfoIconFullRing(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 680 310",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "planetGrad",
    cx: "38%",
    cy: "35%",
    r: "58%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#AFA9EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#7F77DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#26215C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "shineGrad",
    cx: "35%",
    cy: "30%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EEEDFE",
    stopOpacity: 0.55
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EEEDFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glowGrad",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7F77DD",
    stopOpacity: 0.35
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7F77DD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "planetClip"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 152,
    r: 90
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ringFront"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 152,
    width: 360,
    height: 80
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ringBack"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 100,
    width: 360,
    height: 52
  })))), /*#__PURE__*/React.createElement("ellipse", {
    cx: 340,
    cy: 152,
    rx: 130,
    ry: 130,
    fill: "url(#glowGrad)",
    style: {
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 340,
    cy: 160,
    rx: 155,
    ry: 28,
    fill: "none",
    stroke: "#AFA9EC",
    strokeWidth: 10,
    strokeOpacity: 0.38,
    clipPath: "url(#ringBack)",
    style: {
      fill: "none",
      stroke: "rgb(175, 169, 236)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 10,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 152,
    r: 90,
    fill: "url(#planetGrad)",
    style: {
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#planetClip)",
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 340,
    cy: 130,
    rx: 95,
    ry: 14,
    fill: "#534AB7",
    opacity: 0.45,
    style: {
      fill: "rgb(83, 74, 183)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.45,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 340,
    cy: 164,
    rx: 95,
    ry: 10,
    fill: "#3C3489",
    opacity: 0.38,
    style: {
      fill: "rgb(60, 52, 137)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.38,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 340,
    cy: 187,
    rx: 95,
    ry: 8,
    fill: "#534AB7",
    opacity: 0.28,
    style: {
      fill: "rgb(83, 74, 183)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.28,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 305,
    cy: 132,
    rx: 18,
    ry: 10,
    fill: "#AFA9EC",
    opacity: 0.18,
    style: {
      fill: "rgb(175, 169, 236)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.18,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 370,
    cy: 172,
    rx: 12,
    ry: 7,
    fill: "#CECBF6",
    opacity: 0.12,
    style: {
      fill: "rgb(206, 203, 246)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.12,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 152,
    r: 90,
    fill: "url(#shineGrad)",
    style: {
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 340,
    cy: 160,
    rx: 155,
    ry: 28,
    fill: "none",
    stroke: "#CECBF6",
    strokeWidth: 8,
    strokeOpacity: 0.65,
    clipPath: "url(#ringFront)",
    style: {
      fill: "none",
      stroke: "rgb(206, 203, 246)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 8,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 70,
    r: 1.5,
    fill: "#CECBF6",
    opacity: 0.7,
    style: {
      fill: "rgb(206, 203, 246)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 48,
    r: 1,
    fill: "#EEEDFE",
    opacity: 0.6,
    style: {
      fill: "rgb(238, 237, 254)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155,
    cy: 110,
    r: 1,
    fill: "#CECBF6",
    opacity: 0.5,
    style: {
      fill: "rgb(206, 203, 246)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.5,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 55,
    r: 1.5,
    fill: "#CECBF6",
    opacity: 0.7,
    style: {
      fill: "rgb(206, 203, 246)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.7,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 530,
    cy: 90,
    r: 1,
    fill: "#EEEDFE",
    opacity: 0.6,
    style: {
      fill: "rgb(238, 237, 254)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 240,
    r: 1.2,
    fill: "#CECBF6",
    opacity: 0.5,
    style: {
      fill: "rgb(206, 203, 246)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.5,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175,
    cy: 240,
    r: 1,
    fill: "#EEEDFE",
    opacity: 0.55,
    style: {
      fill: "rgb(238, 237, 254)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.55,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 510,
    cy: 260,
    r: 1,
    fill: "#EEEDFE",
    opacity: 0.6,
    style: {
      fill: "rgb(238, 237, 254)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.6,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 555,
    cy: 190,
    r: 1.5,
    fill: "#CECBF6",
    opacity: 0.65,
    style: {
      fill: "rgb(206, 203, 246)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.65,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 200,
    r: 1,
    fill: "#EEEDFE",
    opacity: 0.45,
    style: {
      fill: "rgb(238, 237, 254)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.45,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 112,
    r: 11,
    fill: "#EEEDFE",
    style: {
      fill: "rgb(238, 237, 254)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331,
    y: 130,
    width: 18,
    height: 52,
    rx: 9,
    fill: "#EEEDFE",
    style: {
      fill: "rgb(238, 237, 254)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanetInfoIconFullRing);
export default __webpack_public_path__ + "static/media/planet_info_icon_full_ring.03c4483142f04c852463ae22c87d5024.svg";
export { ForwardRef as ReactComponent };